"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard").default;
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.useParams = exports.ParamsProvider = exports.ParamsContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _util = require("./util");
var _jsxRuntime = require("react/jsx-runtime");
const ParamsContext = exports.ParamsContext = (0, _util.createNamedContext)('Params');
const ParamsProvider = _ref => {
  let {
    allParams,
    children
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ParamsContext.Provider, {
    value: {
      params: {
        ...allParams
      }
    },
    children: children
  });
};
exports.ParamsProvider = ParamsProvider;
const useParams = () => {
  const paramsContext = (0, _react.useContext)(ParamsContext);
  if (paramsContext === undefined) {
    throw new Error('useParams must be used within a ParamsProvider');
  }
  return paramsContext.params;
};
exports.useParams = useParams;